import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { parseQueryString } from 'utils/url';
import { useApi } from 'services/api';
import { getConfiguredTimezone } from 'utils/datetime';

import { processAggNotifs } from './utils';

const useTimelineNotifications = (options) => {
  const api = useApi();
  const location = useLocation();
  const timezone = getConfiguredTimezone();
  const queryParams = parseQueryString(location.search);
  const queryAck = queryParams.ack || 0;
  const mql = queryParams.q || 'last 24 hours';

  return useQuery({
    ...options,
    queryKey: ['notifications', 'timeline', timezone, queryAck, mql],
    queryFn: async () => {
      const response = await api.get('/search/query', {
        params: {
          query: `${mql} acknowledged=${queryAck} | countby sensorId, typeId, typeDescription, severityId, severityName, acknowledged, categoryDescription, @day`,
          context: [],
          searchType: 'O_NOTIFICATIONS',
          timezone,
        },
      });

      return processAggNotifs(response.results);
    },
  });
};

export default useTimelineNotifications;
